(() => {
  const pageEl = () => document.querySelector('[data-pitb-cart-page]');
  if (!pageEl()) return;

  const DEFAULT_METHOD = 'event';

  const syncTotals = (method) => {
    if (window.PITBEntryFee && typeof window.PITBEntryFee.syncEstimatedTotals === 'function') {
      window.PITBEntryFee.syncEstimatedTotals(method);
    }
  };

  const setUi = (method) => {
    const root = pageEl();
    if (!root) return;
    const next = method === 'self_collect' ? 'self_collect' : DEFAULT_METHOD;
    root.setAttribute('data-pitb-collection', next);
    root.querySelectorAll('[data-pitb-collection-option]').forEach((btn) => {
      const selected = btn.getAttribute('data-pitb-collection-option') === next;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    const input = root.querySelector('[data-pitb-collection-input]');
    if (input) input.value = next;
    const label = root.querySelector('[data-pitb-collection-label]');
    if (label) label.value = next === 'self_collect' ? 'Self-collect Only' : 'Visit the Event';
    // Visit: show entry fee in estimated total immediately.
    // Self-collect: remove fee from estimated total immediately.
    syncTotals(next);
  };

  const persist = async (method) => {
    const next = method === 'self_collect' ? 'self_collect' : DEFAULT_METHOD;
    setUi(next);
    if (window.PITBBooking && typeof window.PITBBooking.switchCollectionMethod === 'function') {
      await window.PITBBooking.switchCollectionMethod(next);
      syncTotals(next);
      return;
    }
    // Fallback when booking JS is not loaded yet.
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            pitb_collection_method: next,
            'Collection method': next === 'self_collect' ? 'Self-collect Only' : 'Visit the Event',
            pitb_pickup_date: '',
            pitb_timeslot: '',
            'Pickup date': '',
            'Pickup timeslot': '',
          },
        }),
      });
      if (window.PITBEntryFee && typeof window.PITBEntryFee.applyCollectionSwitch === 'function') {
        await window.PITBEntryFee.applyCollectionSwitch(next);
      }
    } catch (_) {
      /* keep UI selection even if the attribute write fails */
    }
    syncTotals(next);
  };

  document.addEventListener('click', (event) => {
    const btn = event.target && event.target.closest && event.target.closest('[data-pitb-collection-option]');
    if (!btn || !pageEl() || !pageEl().contains(btn)) return;
    event.preventDefault();
    const method = btn.getAttribute('data-pitb-collection-option');
    if (!method || btn.classList.contains('is-selected')) return;
    persist(method);
  });

  const ensureDefaultCollection = async () => {
    const page = pageEl();
    if (!page) return;

    const waitForBooking = () =>
      new Promise((resolve) => {
        if (window.PITBBooking && typeof window.PITBBooking.switchCollectionMethod === 'function') {
          resolve(window.PITBBooking);
          return;
        }
        let attempts = 0;
        const timer = window.setInterval(() => {
          attempts += 1;
          if (window.PITBBooking && typeof window.PITBBooking.switchCollectionMethod === 'function') {
            window.clearInterval(timer);
            resolve(window.PITBBooking);
          } else if (attempts >= 40) {
            window.clearInterval(timer);
            resolve(null);
          }
        }, 50);
      });

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) {
        setUi(DEFAULT_METHOD);
        return;
      }
      const cart = await res.json();
      const stored = cart.attributes && cart.attributes.pitb_collection_method;
      // First open / no stored choice → default to Visit the Event (option 1).
      const method = stored === 'self_collect' ? 'self_collect' : DEFAULT_METHOD;
      setUi(method);

      const booking = await waitForBooking();
      if (booking && typeof booking.applyCatalogMode === 'function') {
        booking.applyCatalogMode(method);
        if (typeof booking.refreshCapacity === 'function') booking.refreshCapacity();
        if (typeof booking.syncCheckoutGate === 'function') booking.syncCheckoutGate();
      }

      if (!stored) {
        await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              pitb_collection_method: DEFAULT_METHOD,
              'Collection method': 'Visit the Event',
            },
          }),
        });
      }
      syncTotals(method);
    } catch (_) {
      setUi(DEFAULT_METHOD);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureDefaultCollection, { once: true });
  } else {
    ensureDefaultCollection();
  }
})();
